import { render, staticRenderFns } from "./PersonFormDialog.vue?vue&type=template&id=581dacae&scoped=true"
import script from "./PersonFormDialog.vue?vue&type=script&lang=js"
export * from "./PersonFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonFormDialog.vue?vue&type=style&index=0&id=581dacae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581dacae",
  null
  
)

export default component.exports